var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-8"},[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("header-actions")],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_vm._t("card-content")],2)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25913849","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Quickcard.vue
// module id = u6Sv
// module chunks = 0